import { Form, Switch, Typography } from "antd";
import { openNotification } from "../../../Components/Notification";
import { useLoader } from "../../../Context/LoaderContext";

const SyncWithGoogleCalendar = () => {
  const { isLoading } = useLoader();

  return (
    <Form.Item
      name="addEventsToCalendar"
      label={
        <Typography.Title
          level={5}
          type="secondary"
          style={{ margin: 0, fontWeight: "normal" }}
        >
          Add events to google calendar
        </Typography.Title>
      }
      style={{ margin: 0 }}
    >
      <Switch
        loading={isLoading}
        checkedChildren="Yes"
        unCheckedChildren="No"
        style={{ marginLeft: 16 }}
        onChange={() =>
          openNotification("success", "Events added to calendar", "")
        }
      />
    </Form.Item>
  );
};

export default SyncWithGoogleCalendar;
